import src from "IMAGE";
export default { src, width: 158, height: 44, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ACMDMFwhAy5VJQMzYB4DKVE8IAxDY0MDVz4iFEolAzRhABMCGjgWAh44JgM1ZR4DKVA8Iw1DZEMDVzgeCzshAy1VaEkK+viw0tMAAAAASUVORK5CYII="};
